import request from "@/axios/axios";

export function fetchListError(query) {
  return request({
    url: "/remit/errorOrder",
    method: "post",
    data: query
  });
}
export function fetchList(query) {
  return request({
    url: "/remit/listPage",
    method: "post",
    data: query
  });
}

export function getDayStatistics(query) {
  return request({
    url: "/remit/statistics",
    method: "post",
    data: query
  });
}

export function getCompleteBankAccount(id) {
  return request({
    url: "/remit/info/" + id,
    method: "get"
  });
}

export function getAgentList(query) {
  return request({
    url: "/agent/list",
    method: "post",
    data: query
  });
}

export function getNotifyList(query) {
  return request({
    url: "/notifyRecord/page",
    method: "post",
    data: query
  });
}

// 同步
export function getDaySynchronism(query) {
  return request({
    url: "/remit/syncState",
    method: "post",
    data: query
  });
}

export function getDayReissue(query) {
  return request({
    url: "/remit/remitNotify",
    method: "post",
    data: query
  });
}
// 成功/失败fail
export function remitSuccess(query) {
  return request({
    url: "/remit/editOrderStateSuccess",
    method: "post",
    data: query
  });
}

export function remitFail(query) {
  return request({
    url: "/remit/editOrderStateFail",
    method: "post",
    data: query
  });
}

/**
 * 订单设置成功
 * @param {*} data 
 * @returns 
 */
export function remit2SuccessAndApi(data) {
  return request({
    url: "/remit/editOrder2SuccessAndApi",
    method: "post",
    data
  });
}

export function orderReminderCancel(query) {
  return request({
    url: "/remit/orderReminderCancel",
    method: "post",
    data: query
  });
}

// 查看状态
export function getRepayStatus(data) {
  return request({
    url: "/remit/queryState",
    method: "post",
    data
  });
}

// 退款
export function getRefund(data) {
  return request({
    url: "/remit/firstAudit",
    method: "post",
    data
  });
}

// 审核
export function getRepayExamine(data) {
  return request({
    url: "/remit/secondAudit",
    method: "post",
    data
  });
}
// 通道名称
export function fetchChannelList(data) {
  return request({
    url: "/channel/list",
    method: "post",
    data
  });
}

// 审核催款
export function goReminder(query, sysType) {
  return request({
    url: "/remit/reminderAuth",
    method: "post",
    data: query,
    sysType: sysType
  });
}

// 冻结订单
export function getWithdrawFrozen(data) {
  return request({
    url: "/remit/freeze",
    method: "post",
    data
  });
}
// 查询所有商户
export function selectAllMerchantByType(data) {
  return request({
    url: "/merchant/payOrder/selectAllMerchantByType",
    method: "post",
    data
  });
}
// 查询所有通道
export function selectAllChannelByType(data) {
  return request({
    url: "/merchant/payOrder/selectAllChannelByType",
    method: "post",
    data
  });
}
// 查询所有通道
export function selectAllChannelCodeByType(data) {
  return request({
    url: "/merchant/payOrder/selectAllChannelCodeByType",
    method: "post",
    data
  });
}
// 测试回调
export function testCallback(data) {
  return request({
    url: "/merchant/payOrder/testCallback",
    method: "post",
    data
  });
}
// 测试回调
export function uploadImage(data) {
  return request({
    url: "/merchant/payOrder/uploadImage",
    method: "post",
    data
  });
}
// 查询
export function queryMerchant(params) {
  return request({
    url: `/merchant/list/queryMerchant`,
    method: "get",
    params
  });
}

// API代付订单导出
export function exportApiOrder(data) {
  return request({
    url: '/excel/getRemitOrderExcel',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
// 请求下单
export function handlePostponeOrder(data) {
  return request({
    url: "/remit/handlePostponeOrder",
    method: "post",
    data
  });
}
// 获取通道
export function queryChannelByMerchantByRemit(data) {
  return request({
    url: "/merchant/list/queryBindChannelsByParams",
    method: "post",
    data
  });
}
// 获取(多个商户)通道
export function batchQueryBindChannelsByParams(data) {
  return request({
    url: "/merchant/list/batchQueryBindChannelsByParams",
    method: "post",
    data
  });
}
/**
 * 代付凭证查询
 * @param {Long} id 
 * @returns 
 */
export function queryRemitCertification(id) {
  return request({
    url: "/remit/certificationQuery/" + id,
    method: "post",
  });
}

/**
 * 失败待退款订单重新提交下单
 * 
 * @param {json} data 
 * @returns 
 */
export function resubmitRefundingOrder(data) {
  return request({
    url: "/remit/refundingOrderResubmit",
    method: "post",
    data
  });
}

/**
 * 失败待退款订单重新批量提交下单
 * 
 * @param {*} data 
 * @returns 
 */
export function refundingOrderNewBatchResubmit(data) {
  return request({
    url: "/remit/refundingOrderNewBatchResubmit",
    method: "post",
    data
  });
}

/**
 * 统计(一定时间内)失败待退款订单
 * @returns 
 */
export function countFailProcessingOrder() {
  return request({
    url: "/remit/countFailProcessingOrder",
    method: "post",
  });
}


// WEBPACK FOOTER //
// ./src/api/manage/orderManage/withdrawList.js